/*
 * Small formatting helpers used by the accommodation section content
 * (AccommodationSections.jsx) and, previously, only by
 * SupOrgAccommodationDetails.jsx's own header/gallery code - pulled out
 * here so both that page and AccommodationSections.jsx (now also used
 * by the customer-facing CampDetails.jsx) share exactly one copy
 * instead of drifting apart.
 */

export const CURRENCY_SYMBOLS = {
    INR: '₹',
    USD: '$',
    AED: 'د.إ',
    EUR: '€',
    GBP: '£'
};

export const PRICE_UNIT_LABELS = {
    per_night: 'night',
    per_person: 'person',
    per_unit: 'unit',
    per_bed: 'bed',
    per_package: 'package'
};

export const formatLabel = (value) => {
    if (!value) return '';

    return String(value)
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (letter) => letter.toUpperCase());
};

export const getCurrencySymbol = (currency) => {
    return CURRENCY_SYMBOLS[currency] || '₹';
};

export const getPriceUnit = (priceUnit) => {
    return PRICE_UNIT_LABELS[priceUnit] || 'night';
};

export const formatPrice = (price) => {
    if (price === undefined || price === null || price === '') {
        return '0';
    }

    return Number(price).toLocaleString('en-IN');
};

export const getImageUrl = (image) => {
    if (!image) return null;

    if (typeof image === 'string') {
        return image;
    }

    return image?.url || null;
};
